import { type Theme, alpha, type Components } from '@mui/material/styles';
import { gray, orange } from '../primitives';

export const feedbackCustomizations: Components<Theme> = {
  MuiAlert: {
    styleOverrides: {
      root: () => ({
        borderRadius: 10,
        backgroundColor: `${alpha(orange[900], 0.5)}`,
        border: `1px solid ${alpha(orange[800], 0.5)}`,
        '& .MuiAlert-icon': {
          color: orange[500],
        },
      }),
    },
  },
  MuiDialog: {
    styleOverrides: {
      root: ({ theme }) => ({
        '& .MuiDialog-paper': {
          borderRadius: '10px',
          border: '1px solid',
          borderColor: (theme.cssVariables || theme).palette.divider,
        },
      }),
    },
  },
  MuiLinearProgress: {
    styleOverrides: {
      root: () => ({
        height: 8,
        borderRadius: 8,
        backgroundColor: gray[800],
      }),
    },
  },
};
